import axios, { AxiosRequestConfig } from "axios";
import useSWR, { SWRConfiguration } from "swr";
import { VidletApiError } from "types/Errors";

export interface UseApiGetOptions {
  axiosOptions?: AxiosRequestConfig;
  swrOptions?: SWRConfiguration;
}

const DEFAULT_SWR_OPTIONS: SWRConfiguration = {
  dedupingInterval: 1000 * 5, // 5 seconds
  revalidateOnFocus: false,
};

// https://swr.vercel.app/docs/revalidation#disable-automatic-revalidations
export const SWR_OPTION: { [key: string]: SWRConfiguration } = {
  CALL_ONCE: {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  },
};

export default function useApiGet<T>(
  url: string | null | undefined,
  options?: UseApiGetOptions,
) {
  const key = url || null;
  const { data, ...rest } = useSWR<T, VidletApiError>(
    key,
    key
      ? async (requestUrl) =>
          (await axios.get<T>(requestUrl, options?.axiosOptions)).data
      : null,
    {
      ...DEFAULT_SWR_OPTIONS,
      ...options?.swrOptions,
    } as SWRConfiguration<T, VidletApiError>,
  );
  const isLoading = rest?.error?.response?.status == 503 || rest.isLoading;

  return {
    result: data,
    ...rest,
    isLoading,
  };
}
